import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _props$layout = props.layout,
      layout = _props$layout === void 0 ? {} : _props$layout,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      alignment = props.alignment;
  var bgClass = typeof layout.background !== 'undefined' && layout.background !== '' ? "cb-content-block--".concat(layout.background) : '';
  var paddingClass = typeof layout.padding !== 'undefined' && layout.padding !== '' ? "cb-l-padding-".concat(layout.padding, "--vertical") : '';
  var paddingTopClass = typeof layout.topPadding !== 'undefined' && layout.topPadding !== '' ? "cb-l-padding-".concat(layout.topPadding, "--top") : '';
  var paddingBottomClass = typeof layout.bottomPadding !== 'undefined' && layout.bottomPadding !== '' ? "cb-l-padding-".concat(layout.bottomPadding, "--bottom") : '';
  var marginClass = typeof layout.margin !== 'undefined' && layout.margin !== '' ? "cb-l-margin-".concat(layout.margin, "--vertical") : '';
  var alignClass = typeof alignment !== 'undefined' ? "cb-content-block--".concat(alignment) : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "\n      cb-content-block\n      ".concat(className, "\n      ").concat(bgClass, "\n      ").concat(paddingClass, "\n      ").concat(paddingTopClass, "\n      ").concat(paddingBottomClass, "\n      ").concat(marginClass, "\n      ").concat(alignClass, "\n      ")
  }, children);
};

export default Wrapper;